module.exports = __webpack_public_path__ + "img/hr-level3addon_idle_gun_shadow.9960d01b.png";